export const validateResponse = (responseJSON) => (
  !!(responseJSON &&
  responseJSON.payload &&
  responseJSON.payload[0] &&
  responseJSON.payload[0].label &&
  responseJSON.payload[0].brand &&
  responseJSON.payload[0].brand.label &&
  responseJSON.payload[0].images &&
  responseJSON.payload[0].images[0] &&
  responseJSON.payload[0].images[0].url &&
  responseJSON.payload[0].price &&
  responseJSON.payload[0].price.amount &&
  !Number.isNaN(responseJSON.payload[0].price.amount)
  )
);

export const fetchMainProductData = async (storeUrl, mainProductId) => {
  const response = await fetch(
    `${storeUrl}/products/${mainProductId}`,
    { credentials: 'same-origin' }
  );
  const responseJSON = await response.json();
  if (validateResponse(responseJSON)) {
    return {
      productID: mainProductId,
      productName: responseJSON.payload[0].label,
      productManufacturer: responseJSON.payload[0].brand.label,
      productImgUrl: responseJSON.payload[0].images[0].url,
      productPrice: parseFloat((responseJSON.payload[0].price.amount / 100).toFixed(2))
    };
  }
  throw new Error('Invalid data received from Store API endpoint for main product.');
};
